export default __webpack_public_path__ + "static/logo19-120a2be02b36ac2f16ae8abc44ff6be0.png";